
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, Clock } from "lucide-react";

interface ErrorDisplayProps {
  error: string | null;
  isQuotaExceeded: boolean;
  isRateLimited: boolean;
  cooldownRemaining: number;
}

const ErrorDisplay = ({
  error,
  isQuotaExceeded,
  isRateLimited,
  cooldownRemaining,
}: ErrorDisplayProps) => {
  if (!error) return null;

  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>
        {isQuotaExceeded
          ? "API Quota Exceeded"
          : isRateLimited
          ? "Rate Limit Exceeded"
          : "Error"}
      </AlertTitle>
      <AlertDescription>
        {isQuotaExceeded ? (
          <p>
            We've hit our API quota for today. Please try again tomorrow or
            contact support for assistance.
          </p>
        ) : isRateLimited ? (
          <div className="flex flex-col space-y-2">
            <p>
              You've reached the rate limit for profile reviews. Please try again
              later.
            </p>
            {cooldownRemaining > 0 && (
              <div className="flex items-center text-sm">
                <Clock className="mr-1 h-3 w-3" />
                <span>Try again in approximately {cooldownRemaining} minutes</span>
              </div>
            )}
          </div>
        ) : (
          <p>{error}</p>
        )}
      </AlertDescription>
    </Alert>
  );
};

export default ErrorDisplay;
